function initHeroVideo(videoHero, isInsideCarousel) {
  if (!videoHero.querySelector('video')) {
    return;
  }
  var videoLoaded = false;
  var mobileImageLoaded = false;
  handleMobileOrDesktop();
  window.addEventListener('resize', handleMobileOrDesktop);

  function handleMobileOrDesktop() {
    if (window.innerWidth >= 722) {
      var videoElement = videoHero.querySelector('video');
      if (!videoLoaded && videoElement) {
        videoElement.src = videoElement.getAttribute('data-src');
        videoElement.setAttribute('poster', videoElement.getAttribute('data-poster'));
        videoLoaded = true;
      }
      videoElement.addEventListener('playing', () => {
        videoHero.classList.add('has-started');
      });
      initVideoPlayer(); // Call initVideoPlayer instead of initHeroVideo
    }
    else if (!mobileImageLoaded) {
      videoHero.style.backgroundImage = "url(" + videoHero.getAttribute('data-mobile-image') + ")";
      mobileImageLoaded = true;
    }
  }

  function initVideoPlayer() {
    var videoAspectRatio = 28.125; // 1920/540
    var videoPlayerInitiated = false;
    setupVideoPlayer();
    window.addEventListener('resize', setupVideoPlayer);

    function setupVideoPlayer() {
      if (window.innerWidth >= 722) {
        if (!document.body.classList.contains('CampaignPage-top-level') && !isInsideCarousel) {
          videoHero.style.paddingTop = videoHero.querySelector('.video-wrapper').offsetWidth / 100 * videoAspectRatio - 1 + 'px';
        }

        if (!videoPlayerInitiated) {
          // Make sure initializeVideoFileControls is available globally
          if (typeof initializeVideoFileControls === 'function') {
            initializeVideoFileControls(videoHero, isInsideCarousel);
          } else {
            console.error('initializeVideoFileControls function not found');
          }
          videoPlayerInitiated = true;
        }
        videoHero.style.backgroundImage = null;
      }
      else if (window.innerWidth < 722) {
        videoHero.style.paddingTop = '';
        videoHero.style.backgroundImage = "url(" + videoHero.getAttribute('data-mobile-image') + ")";
      }
    }
  }
}

// Make the function globally available
window.initHeroVideo = initHeroVideo;

(function () {
  var videoHeroes = document.querySelectorAll('.hero-video-block');
  if (videoHeroes.length === 0) {
    return;
  }

  videoHeroes.forEach((videoHero) => {
    let isInsideCarousel = videoHero.parentElement.parentElement.classList.contains('hero-carousel-block__wrapper');
    if (!isInsideCarousel) {
      initHeroVideo(videoHero, isInsideCarousel);
    }
  });
})();